import {
  Flex,
  FormLabel,
  Heading,
  Image,
  Input,
  Link,
  Modal,
  ModalContent,
  ModalOverlay,
  Text,
  Textarea,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useContext, useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import LoginButton from "../../components/LoginButton/LoginButton";
import "./Contact.scss";
import { Context } from "../../shared/Context/Context";
import Loading from "../../components/Loading/Loading";
import { Bounce, Fade } from "react-awesome-reveal";
import { FormattedMessage } from "react-intl";

const Contact = () => {
  const form = useRef();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { tabletOrLess } = useContext(Context);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);
    emailjs
      .sendForm(
        process.env.REACT_APP_SERVICE_ID_EMAILJS,
        process.env.REACT_APP_TEMPLATE_ID_EMAILJS,
        form.current,
        process.env.REACT_APP_PUBLIC_KEY_EMAILJS
      )
      .then(
        () => {
          setLoading(false);
          setSuccess(true);
          setTimeout(() => {
            onClose();
            setSuccess(false);
          }, 2000);
        },
        () => {
          setSuccess(false);
          setLoading(false);
        }
      );
  };

  return (
    <Flex
      w="100vw"
      h={tabletOrLess ? "100vh" : "87vh"}
      flexDir="column"
      justify="space-around"
      align="center"
    >
      <Bounce triggerOnce>
        <Heading
          mt={tabletOrLess && "100px"}
          fontSize={tabletOrLess && "20px"}
          p="0px 20px"
          textAlign="center"
          mb={tabletOrLess && "50px"}
        >
          <FormattedMessage
            id="app.contact.heading"
          />
        </Heading>
      </Bounce>
      <iframe
        className="mapa"
        title="ubicación escuela"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2984.238199755362!2d1.6161698154319537!3d41.585729379246494!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12a469de197ca953%3A0xf05b659904c69b6c!2sCarrer%20de%20Sant%20Mag%C3%AD%2C%20100%2C%2008700%20Igualada%2C%20Barcelona!5e0!3m2!1ses!2ses!4v1662576887505!5m2!1ses!2ses"
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>

      <Modal
        motionPreset="slideInBottom"
        isOpen={isOpen}
        onClose={onClose}
        isCentered
      >
        <ModalOverlay />
        <ModalContent
          w="100vw"
          h="100vh"
          backgroundColor="#FFFFFF"
          border="3px solid black"
        >
          <Image
            w="40px"
            position="absolute"
            right={!tabletOrLess && "0"}
            top="0"
            left={tabletOrLess && "0"}
            mt={tabletOrLess ? "25px" : "25px"}
            cursor="pointer"
            mr={!tabletOrLess && "20px"}
            ml={tabletOrLess && "20px"}
            src="https://res.cloudinary.com/dhp2zuftj/image/upload/v1654865079/MontseProyect/remove_1_vwlrs4.png"
            onClick={onClose}
            alt="close"
          />
          <Image
            position="absolute"
            w={tabletOrLess && "50%"}
            right={!tabletOrLess && "0"}
            top={!tabletOrLess && "0"}
            bottom={tabletOrLess && "0"}
            left={!tabletOrLess && "0"}
            pt="30px"
            alt="gif gracioso"
            src="/assets/Pocoyo.gif"
          />
          <form
            className="formEmail"
            ref={form}
            autoComplete="off"
            onSubmit={sendEmail}
          >
            <Flex
              w="100%"
              justify="center"
              align="center"
              flexDir="column"
              m="40px"
            >
              <FormLabel fontWeight="bold">
                <FormattedMessage
                  id="app.contact.form.label.name"
                />
              </FormLabel>
              <Input
                required
                placeholder="Escribe aquí tu nombre..."
                border="none"
                backgroundColor="#FFFFFF"
                mt="15px"
                name="from_name"
                p="8px"
                fontWeight="bold"
                borderBottom="3px solid black"
                textAlign="center"
                minW="60%"
                _focus={{ outline: "none" }}
              />
            </Flex>
            <Flex
              w="100%"
              justify="center"
              align="center"
              flexDir="column"
              m="40px"
            >
              <FormLabel fontWeight="bold">
                <FormattedMessage
                  id="app.contact.form.label.email"
                />
              </FormLabel>
              <Input
                required
                placeholder="Escribe aquí tu email..."
                border="none"
                backgroundColor="#FFFFFF"
                mt="15px"
                name="from_email"
                p="8px"
                fontWeight="bold"
                borderBottom="3px solid black"
                textAlign="center"
                minW="60%"
                _focus={{ outline: "none" }}
              />
            </Flex>
            <Flex
              w="100%"
              justify="center"
              align="center"
              flexDir="column"
              m="40px"
            >
              <FormLabel fontWeight="bold">
                <FormattedMessage
                  id="app.contact.form.label.message"
                /></FormLabel>
              <Textarea
                required
                placeholder="Escribe aquí tu mensaje..."
                border="none"
                name="message"
                backgroundColor="#FFFFFF"
                mt="15px"
                fontWeight="bold"
                p="8px"
                borderBottom="3px solid black"
                textAlign="center"
                minW="60%"
                maxH="90px"
                minH="50px"
                maxW="396px"
                _focus={{ outline: "none" }}
              />
            </Flex>
            <Flex>
              {loading ? (
                <Loading mini />
              ) : success ? (
                <Text
                  p="10px"
                  display="flex"
                  justifyContent="flex-start"
                  alignItems="center"
                  fontWeight="bold"
                  h="50px"
                  w="17vw"
                  backgroundColor="#c6f6d5"
                >
                  <Image
                    mr="20px"
                    w="30px"
                    src="/assets/comprobado.png"
                    alt="check"
                  />
                  <FormattedMessage
                    id="app.contact.form.label.response"
                  />
                </Text>
              ) : (
                <LoginButton texto="Mandar correo" />
              )}
            </Flex>
          </form>
        </ModalContent>
      </Modal>
      <Flex w="100%" flexWrap="wrap" justify="center" align="center">
        <Fade cascade triggerOnce>
          <Flex
            display="flex"
            justifyContent="center"
            alignItems="center"
            onClick={onOpen}
            mt="30px"
            backgroundColor="#ff6e6c"
            borderRadius="10px"
            p="10px"
            mr={tabletOrLess ? "0px" : "50px"}
            cursor="pointer"
          >
            <Image
              w={tabletOrLess && "30px"}
              h={tabletOrLess && "30px"}
              maxW="50px"
              maxH="50px"
              mr="30px"
              src="/assets/gmail.png"
              alt="icono gmail"
            />
            <Text fontWeight="bold">m.archela.kingdomls@gmail.com</Text>
          </Flex>
          <Link
            display="flex"
            backgroundColor="#ff6e6c"
            borderRadius="10px"
            p="10px"
            mr={tabletOrLess ? "0px" : "50px"}
            mt="30px"
            justifyContent="center"
            alignItems="center"
            cursor="pointer"
            href="https://github.com/Corocottax"
          >
            <Image
              w={tabletOrLess && "30px"}
              h={tabletOrLess && "30px"}
              maxW="50px"
              maxH="50px"
              mr="30px"
              src="/assets/GitHub.png"
              alt="icono github"
            />
            <Text fontWeight="bold">
              <FormattedMessage
                id="app.contact.form.label.github"
              /></Text>
          </Link>
          <Link
            display="flex"
            backgroundColor="#ff6e6c"
            borderRadius="10px"
            p="10px"
            mt="30px"
            mb={tabletOrLess && "30px"}
            justifyContent="center"
            alignItems="center"
            cursor="pointer"
            href="tel:+34649544083"
          >
            <Image
              w={tabletOrLess && "30px"}
              h={tabletOrLess && "30px"}
              maxW="50px"
              maxH="50px"
              mr="30px"
              src="/assets/telefono.png"
              alt="icono telefono"
            />
            <Text fontWeight="bold">+34 649 54 40 83</Text>
          </Link>
        </Fade>
      </Flex>
    </Flex>
  );
};

export default Contact;
